import React from 'react';
import type { ColDef } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getNonQuantoDays, saveNonQuantoDaysBatch } from '../../api/nonDays';
import type { NonQuantoDay } from '../../types/NonDays';
import { dateColumnProps } from '../../utils/dateColumn';
import { t } from '../../i18n/t';

const columnDefs: ColDef<NonQuantoDay>[] = [
  {
    field: 'recId',
    headerName: t('nonQuantoDays.columns.recId'),
    width: 110,
    editable: false,
    cellDataType: 'number',
  },
  {
    field: 'dDate',
    headerName: t('nonQuantoDays.columns.dDate'),
    width: 160,
    editable: true,
    sort: 'desc',
    ...dateColumnProps<NonQuantoDay>('dDate'),
  },
  {
    field: 'comment',
    headerName: t('nonQuantoDays.columns.comment'),
    flex: 1,
    minWidth: 200,
    editable: true,
  },
];

const newDefaults = (): Partial<NonQuantoDay> => ({
  recId: 0,
  dDate: null as unknown as string,
  comment: '',
});

export function NonQuantoDaysPage() {
  return (
    <LopCrudPage<NonQuantoDay>
      resourceCode="nonQuantoDays"
      titleKey="nonQuantoDays.pageTitle"
      idField="recId"
      getRows={getNonQuantoDays}
      saveBatch={(added, modified, deletedIds) =>
        saveNonQuantoDaysBatch(added, modified, deletedIds as number[])
      }
      columnDefs={columnDefs}
      newRowDefaults={newDefaults}
    />
  );
}
